<template>
  <div class="container">
    <Header></Header>
    <VideoList :data="videoList"></VideoList>
  </div>
</template>

<script>
import Header from "@/modules/header.vue";
import VideoList from "@/modules/videoList.vue";
import {
  getCategories,
  pageCourse
} from "@/assets/js/axios.js";

export default {
  name: "vrpractive",

  data() {
    return {
      navbarData: [],
      videoList: []
    };
  },

  created() {
    getCategories().then(data => {
      if (parseInt(data.code) === 1) {
        this.navbarData = data;
        pageCourse(this.navbarData.data[5].ccid).then(data => {
          if (parseInt(data.code) === 1) {
            this.videoList = data.data.dataList;
          }
        });
      } else {
        this.videoList = 0;
      }
    });
  },
  components: {
    Header,
    VideoList
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Vrpractice.vue